import { useState } from 'react';

const KEY = 'aadpa_theme';

export function initTheme() {
  if (localStorage.getItem(KEY) === 'dark') document.documentElement.classList.add('dark');
}

export function useTheme() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains('dark'));
  const toggle = () => {
    const next = document.documentElement.classList.toggle('dark');
    localStorage.setItem(KEY, next ? 'dark' : 'light');
    setDark(next);
  };
  return { dark, toggle };
}
